package com.partejar.app.core.security

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

@Composable
actual fun rememberBiometricAuthenticator(): BiometricAuthenticator = remember { JsUnsupportedBiometricAuthenticator }

private data object JsUnsupportedBiometricAuthenticator : BiometricAuthenticator {
    override fun availability() = BiometricAvailability.UNSUPPORTED
    override suspend fun authenticate(title: String, reason: String) = BiometricAuthenticationResult.Unavailable
}
